import { z } from 'zod';

export const groupSchema = z.object({
  id: z.guid(),
  name: z.string(),
  siteID: z.guid(),
  providerID: z.guid(),
});
